
import './viewAllAssignedStakeholders.css';
import React, { useState, useEffect } from "react";

import jwt from 'jwt-decode';
import { GET_APPLICATION_LIST, GET_ALL_STAKEHOLDERS, GET_STAKEHOLDER_BY_URN } from '../../../common/URLs';
import back from '../../../images/backButton.png';
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { KeyboardArrowLeftRounded } from '@mui/icons-material'
import { Link as RouterLink } from 'react-router-dom';
import { Fab, IconButton, Tooltip } from '@mui/material';
import { Container, Row, Col, Stack, Table } from 'react-bootstrap';
import { PROD } from '../../../common/constants';
import { Box, CardContent, Card, Typography, Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { lastFiveDigitsComparator } from '../../../common/commonFunction';
import { useTranslation } from 'react-i18next';
import { RemoveRedEyeIcon } from '../../../common/icons';
import apiClient from '../../../axios';

function ViewAllAssignedStakeholders() {
  const { t } = useTranslation();
  const [stakeHolders, setStakeHolders] = useState();
  const [viewstakeHolders, setViewStakeHolders] = useState();
  const [userID, setUserId] = useState();
  const [stakeholderData, setStakeHolderData] = useState();
  useEffect(() => {

    setUserId(location.state.userid);

  }, []);

  const navigate = useNavigate();
  const location = useLocation();
  const userId = location.state.userid;
  const backScrutiny = location.state.backScrutiny;

  useEffect(() => {
    if (userId) {
      getAllAssignedStakeholders();
    }
  }, [userId]);
  const onView = (urnSelected, createdBy, registrationCompletedBy, registrationCompleted, stakeholderType, growerSubCategory) => {
    const userData = {
      "urnSelected": urnSelected,
      "userId": userId,
      "createdBy": createdBy,
      "registrationCompletedBy": registrationCompletedBy,
      "registrationCompleted": registrationCompleted,
      "isScrutinyView": true

    }
    if (backScrutiny === true) {
      if (stakeholderType === "Transporter") {
        navigate("/registrationHome/scrutiny/registrationDetailsTransporter", { state: { URN: urnSelected, registrationCompleted: registrationCompleted, data: userData } })
      }
      else if (stakeholderType === "HIT") {
        navigate("/registrationHome/scrutiny/registrationDetailsHit", { state: { URN: urnSelected, registrationCompleted: registrationCompleted, data: userData } })
      }
      else if (stakeholderType === "LLE") {
        navigate("/registrationHome/scrutiny/registrationDetailsLle", { state: { URN: urnSelected, registrationCompleted: registrationCompleted, data: userData } })
      }
      else if (stakeholderType === "Interim Storage Operator") {
        navigate("/registrationHome/scrutiny/registrationDetailsTempStorage", { state: { URN: urnSelected, registrationCompleted: registrationCompleted, data: userData } })
      }
      else if (growerSubCategory == "Individual" || growerSubCategory == "JFMC" || growerSubCategory === "Other Agency") {
        navigate("/registrationHome/scrutiny/registrationDetails", { state: { URN: urnSelected, registrationCompleted: registrationCompleted, data: userData } })
      }
      else if (growerSubCategory === "Co-operative" || growerSubCategory === "FPO" || growerSubCategory === "SHG" || growerSubCategory === "FPC") {
        navigate("/registrationHome/scrutiny/registrationMemberDetails", { state: { URN: urnSelected, registrationCompleted: registrationCompleted, data: userData } })
      }
      else if (growerSubCategory === "Forest") {
        navigate("/registrationHome/scrutiny/registrationDetailsForest", { state: { URN: urnSelected, registrationCompleted: registrationCompleted, data: userData } })
      }
      else {
        // navigate("/registrationHome/scrutiny/onView", { state: { data: userData } })
      }
    }
    else {
      if (stakeholderType === "Transporter") {
        navigate("/registrationHome/dashboard/registrationDetailsTransporter", { state: { URN: urnSelected, registrationCompleted: registrationCompleted, data: userData } })
      }
      else if (stakeholderType === "HIT") {
        navigate("/registrationHome/dashboard/registrationDetailsHit", { state: { URN: urnSelected, registrationCompleted: registrationCompleted, data: userData } })
      }
      else if (stakeholderType === "LLE") {
        navigate("/registrationHome/dashboard/registrationDetailsLle", { state: { URN: urnSelected, registrationCompleted: registrationCompleted, data: userData } })
      }
      else if (stakeholderType === "Interim Storage Operator") {
        navigate("/registrationHome/dashboard/registrationDetailsTempStorage", { state: { URN: urnSelected, registrationCompleted: registrationCompleted, data: userData } })
      }
      else if (growerSubCategory == "Individual" || growerSubCategory == "JFMC" || growerSubCategory === "Other Agency") {
        navigate("/registrationHome/dashboard/registrationDetails", { state: { URN: urnSelected, registrationCompleted: registrationCompleted, data: userData } })
      }
      else if (growerSubCategory === "Co-operative" || growerSubCategory === "FPO" || growerSubCategory === "SHG" || growerSubCategory === "FPC") {
        navigate("/registrationHome/dashboard/registrationMemberDetails", { state: { URN: urnSelected, registrationCompleted: registrationCompleted, data: userData } })
      }
      else if (growerSubCategory === "Forest") {
        navigate("/registrationHome/dashboard/registrationDetailsForest", { state: { URN: urnSelected, registrationCompleted: registrationCompleted, data: userData } })
      }
      else {
        // navigate("/registrationHome/dashboard/onView", { state: { data: userData } })
      }
    };
  }

  function getAllAssignedStakeholders() {
    apiClient
      .post(GET_APPLICATION_LIST,
        {
          "userID": userId,
          "status": "Pending_Approval",
          "regStatus": location?.state?.isResourceUpdate
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        setViewStakeHolders(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  const viewStakeholdersArray = viewstakeHolders?.scrutinyWorkFlowStepDetails;
  const columns = [
    {
      field: 'id', headerName: 'S.No', width: 60,
      renderCell: (index) => index.api.getRowIndex(index.row.id) + 1
    },
    {
      field: 'name', headerName: t('preReg.name'), width: 180,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', width: '100%' }}>
          {params.value}
        </div>
      ),
      valueGetter: (params) => params.value
    },
    { field: 'urn', headerName: 'URN', width: 180, sortComparator: (a, b) => lastFiveDigitsComparator(a, b) },
    { field: 'stakeholderType', headerName: 'Stakeholder Type', width: 200 },
    { field: 'status', headerName: 'Status', width: 180 },
    { field: 'totalQuantity', headerName: 'Total Quantity (in MT)', width: 140, type: "number" },
    { field: 'committedQuantity', headerName: 'Committed Quantity (in MT)', width: 140, type: "number" },
    {
      field: 'action', headerName: 'Action', width: 150,
      renderCell: (cellValues) => {
        return (
          <Tooltip title="View">
            <IconButton
              color="primary"
              onClick={() => onView(cellValues?.row?.urn, cellValues?.row?.createdBy, cellValues?.row?.registrationCompletedBy, cellValues?.row?.registrationCompleted, cellValues?.row?.stakeholderType, cellValues?.row?.stakeholderSubCategory)}
            >
              <RemoveRedEyeIcon />
            </IconButton>
          </Tooltip>
        );
      }
    },
  ];

  return (
    <>
      {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG48</p>}
      <Card>
        <CardContent>
          <div style={{ display: "inline-flex" }}>
            <Typography variant="h4" sx={{ mb: 2 }}>
              <Fab component={RouterLink} to={backScrutiny === true ? '../scrutiny' : '../dashboard'} size="small" aria-label="back" title='Back'>
                <KeyboardArrowLeftRounded />
              </Fab>
            </Typography>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <div className="hitDetailsText">Pending Applications</div>
          </div>
          {viewStakeholdersArray &&
            <Box style={{ height: 500, width: '100%', marginTop: "2vh" }}>
              <DataGrid
                sx={{
                  "& .MuiDataGrid-columnHeaderTitle": {
                    whiteSpace: "normal",
                    lineHeight: "normal"
                  },
                  "& .MuiDataGrid-columnHeader": {
                    height: "unset !important"
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    maxHeight: "168px !important"
                  },
                  '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '6px' },
                  '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '12px' },
                  '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '18px' },
                }}
                getRowHeight={() => 'auto'}
                rows={viewStakeholdersArray}
                columns={columns}
                pageSize={10}
                getRowId={(row) => row?.id}
                components={{ Toolbar: QuickSearchToolbar }}
              />
            </Box>}
        </CardContent>
      </Card>
    </>
  );
}
export default ViewAllAssignedStakeholders;

